function applyTheme() {
  const theme = localStorage.getItem('user_theme') || 'light';
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

  let appliedTheme = 'light';

  if (theme === 'dark' || (theme === 'system' && prefersDark)) {
    appliedTheme = 'dark';
  }

  document.documentElement.setAttribute('data-theme', appliedTheme);
}

function updateThemeIcons() {
  const theme = localStorage.getItem('user_theme') || 'light';

  const toggle = document.getElementById('theme-toggle');
  if (!toggle) return;

  toggle.querySelectorAll('svg').forEach(icon => {
    icon.classList.add('hidden');
  });

  if (theme === 'system') {
    document.getElementById('system-icon')?.classList.remove('hidden');
  } else if (theme === 'dark') {
    document.getElementById('moon-icon')?.classList.remove('hidden');
  } else {
    document.getElementById('sun-icon')?.classList.remove('hidden');
  }
}

function initTheme() {
  console.log("Init theme.")
  applyTheme();

  const toggle = document.getElementById('theme-toggle');
  if (toggle) {
    toggle.addEventListener('click', function() {
      // const themes = ['light', 'dark', 'system'];
      const themes = ['light', 'dark'];
      const current = localStorage.getItem('user_theme') || 'light';
      const currentIndex = themes.indexOf(current);
      const nextTheme = themes[(currentIndex + 1) % themes.length];

      localStorage.setItem('user_theme', nextTheme);
      applyTheme();
      updateThemeIcons();
    });
  }

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function() {
    const theme = localStorage.getItem('user_theme');
    if (theme === 'system' || !theme) {
      applyTheme();
    }
  });

  updateThemeIcons();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTheme);
} else {
  initTheme();
}
